module.exports = __webpack_public_path__ + "img/upload-cloud.20ef63d2.svg";